
import { Plotly } from "vue-plotly";
import axios from "axios";

export default {
  components: {
    Plotly,
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      console.log("loadData");
      const { data } = await axios.get("https://92t70y.deta.dev/");

      const { chart, orderbook } = data;

      orderbook.type = "heatmap";
      orderbook.hoverongaps = false;
      orderbook.colorscale = "Blackbody";

      chart.type = "scatter";
      chart.mode = "lines+markers";

      this.data = [orderbook, chart];

      this.loading = false;

      setTimeout(() => {
        this.loadData();
      }, 1000 * 60 * 5);
    },
  },
  data() {
    return {
      loading: true,
      data: [],
      layout: {
        title: "BTCUSDT - Chart & Orderbook",
        height: window.innerHeight,
        paper_bgcolor: "black",
        plot_bgcolor: "#000111",
      },
    };
  },
};
